<template>
    <article class="message is-info block" v-if="!currentFD.deliveries_generated">
        <div class="message-header">Generate Deliveries</div>
        <div class="message-body">
            <div class="block">This will generate deliveries
                for all the <b>active beneficiaries</b>.</div>
            <div class="block">Please make the changes (if any) in Beneficiary data (like changing active status,
                delivery mode etc.) before generating deliveries.</div>
        </div>
        
        <div class="block align-center">
            <div v-if="isLoading || (deliveriesGeneratedCount > 0 && deliveriesGeneratedCount < totalDeliveriesToGenerate)">
                <base-spinner></base-spinner>
                Generating deliveries {{ deliveriesGeneratedCount }} / {{ totalDeliveriesToGenerate }}
                <progress class="progress is-info" :value="deliveriesGeneratedCount" :max="totalDeliveriesToGenerate">15%</progress>
            </div>
            <button v-else-if="!currentFD.deliveries_generated && !deliveriesGenerated" @click="generateDeliveries"
                class="button is-info is-rounded">Generate Deliveries</button>
        </div>
        <br />
    </article>

    <div v-if="!!error" class="notification is-danger">
        <p>{{ error }}</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isLoading: false,
            deliveriesGenerated: false,
            error: null
        }
    },
    computed: {
        currentFD() {
            return this.$store.getters['fd/getCurrentFD'];
        },
        totalDeliveriesToGenerate() {
            return this.$store.getters['delivery/getTotalDeliveriesToGenerate'];
        },
        deliveriesGeneratedCount() {
            return this.$store.getters['delivery/getDeliveriesGeneratedCount'];
        }
    },
    methods: {
        async generateDeliveries() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('delivery/generateDeliveries', {
                    fdID: this.currentFD.id
            });
            } catch (error) {
                this.error = error.message || "Something went wrong!";
                console.log(error);
            }
            this.isLoading = false;
            this.deliveriesGenerated = true;
        }
    }
}
</script>